export default __webpack_public_path__ + "static/media/icon-coin-super.d37e17d2.svg";